/* ModalShare.js */
/* @author: anghello */

import React, { useCallback } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Strings from '../../translations/Translations';
import ShareComponent from './ShareComponent';

export default function ModalShare({open, setOpen, remixPars}) {
  const toggle = useCallback(() => setOpen(!open), [open, setOpen]);

  return (
    <Modal isOpen={open} toggle={toggle} size='lg'>
      <ModalHeader toggle={toggle}>
      {Strings('share_video')}
      </ModalHeader>
      <ModalBody>
        {remixPars && <ShareComponent currentIt={remixPars} />}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggle}>
          {Strings('close')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
